import { render, staticRenderFns } from "./CustomSelectField.vue?vue&type=template&id=63128906&"
import script from "./CustomSelectField.vue?vue&type=script&lang=js&"
export * from "./CustomSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports